import { render, staticRenderFns } from "./reporters.component.html?vue&type=template&id=5f8127ea&scoped=true&"
import script from "./reporters.component.ts?vue&type=script&lang=ts&"
export * from "./reporters.component.ts?vue&type=script&lang=ts&"
import style0 from "./reporters.component.scss?vue&type=style&index=0&id=5f8127ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8127ea",
  null
  
)

export default component.exports